module.exports = __webpack_public_path__ + "Roboto-normal-500.57af64fc644194101c15.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Roboto-normal-500.woff
// module id = 906
// module chunks = 2